import React, { useState } from 'react';
import { Button, Card } from 'tabler-react';
import RemoveLastDirectoryPartOf from '../goBackButton';
import { useAPI } from '../../ApiCalls/useAPI';
import './Complaints.scss';
const { submitComplaint } = useAPI();

export default class Complaints extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            get: [],
            type: [],
            post: [],
            submit: ''
        };
        this.submitComplaints = this.submitComplaints.bind(this);
    }

    getResponse(data) {
        // console.log(data);
        this.setState({
            get: data
        });
    }

    typeResponse(data) {
        this.setState({
            type: data
        });
    }

    submitComplaints() {
        // console.log('submitting complaint');
        var desc = document.getElementById('complaintdesc').value;
        var type = document.getElementById('complainttype').value;
        // console.log(desc);
        // console.log(type);
        submitComplaint(type, desc).then((data) => {
            // console.log(data);
            this.setState({
                post: data
            });
            if (this.state.post.error === false) {
                // console.log('success');
                document.getElementById(
                    'status'
                ).innerHTML = `<div class='successmsg mt-2 mb-2'>${this.state.post.errormsg}</div>`;
            }
        });
    }

    componentDidMount() {
        const { getComplaints } = useAPI();
        getComplaints()
            .then((response) => this.getResponse(response))
            .catch((error) => console.error(error));
        const { complaintType } = useAPI();
        complaintType()
            .then((response) => this.typeResponse(response))
            .catch((error) => console.error(error));
    }

    render() {
        const { get, type, post } = this.state;
        // console.log(post);
        const FirstTab = () => {
            return (
                <div className="FirstTab">
                    <Card
                        title="Complaint about"
                        body={
                            <select
                                id="complainttype"
                                className="complaintoptions form-control mb-1"
                            >
                                {type.map((option) => (
                                    <option value={option.id}>
                                        {option.name}
                                    </option>
                                ))}
                            </select>
                        }
                    />
                    <Card
                        title="Please write details below"
                        body={
                            <div>
                                <textarea
                                    id="complaintdesc"
                                    className="complainttext form-control mt-2 mb-2"
                                    rows="14"
                                    name="description"
                                ></textarea>
                                <Button
                                    type="submit"
                                    onClick={this.submitComplaints}
                                    className="complaintsubmit mb-2"
                                    color="blue"
                                >
                                    Submit
                                </Button>
                                <div id="status"> </div>
                            </div>
                        }
                    />
                </div>
            );
        };
       
        const SecondTab = () => {
            if (get === null || get.length === 0) {
                return (
                    <div className="SecondTab">
                        <div className="container">NO COMPLAINTS FOUND</div>
                    </div>
                );
            }
            return (
                <div className="SecondTab">
                    {get.reverse().map((complaint) => (
                        <Card
                            isCollapsible
                            isCollapsed
                            title={
                                <div className="getcomplaintid">
                                    Complaint Id :- {complaint.complaintid}
                                </div>
                            }
                            body={
                                complaint.status === 'Registered' ? (
                                    <div className="getcomplaintbody">
                                        <div
                                           
                                            className="getcomplaintstatus"
                                        >
                                            <h6>
                                                Status :- {complaint.status}
                                            </h6>
                                        </div>
                                        <div style={{ display: 'flex' }}>
                                            <div className="getcomplaintdate">
                                                <h6>
                                                    {/* Date :- */}
                                                    <TimestampComponent eventdate={complaint.eventdate} />
                                                    {/* {complaint.eventdate} */}
                                                </h6>
                                            </div>
                                            <div className="getcomplainttype">
                                                <h6>
                                                    Type :-
                                                    {complaint.complainttype
                                                        ? complaint.complainttype
                                                        : 'NA'}
                                                </h6>
                                            </div>
                                        </div>
                                        <div className="getcomplaintdes">
                                            {complaint.complaintDescription}
                                        </div>
                                    </div>
                                ) : (
                                    <div className="getcomplaintbody">
                                        <div
                                           
                                            className="getcomplaintstatus"
                                        >
                                            <h6>
                                                Status :- {complaint.status}
                                            </h6>
                                        </div>
                                        <div style={{ display: 'flex' }}>
                                            <div className="getcomplaintdate">
                                                <h6>
                                                <TimestampComponent eventdate={complaint.eventdate} />
                                                </h6>
                                            </div>
                                            <div className="getcomplainttype">
                                                <h6>
                                                    Type :-
                                                    {complaint.complainttype
                                                        ? complaint.complainttype
                                                        : 'NA'}
                                                </h6>
                                            </div>
                                        </div>
                                        <div className="getcomplaintdes">
                                            {complaint.complaintDescription}
                                        </div>
                                        <h4 className="mt-4 m-2">Response</h4>
                                        <div className="getcomplaintdate">
                                            <h6>
                                                Date :-
                                                {
                                                    complaint.complaintResponseDescriptionDate
                                                }
                                            </h6>
                                        </div>
                                        <div className="getcomplaintdes">
                                            {
                                                complaint.complaintResponseDescription
                                            }
                                        </div>
                                    </div>
                                )
                            }
                        />
                    ))}
                </div>
            );
        };

        const TimestampComponent = ({ eventdate }) => {
            // Convert the timestamp to a Date object
            const date = new Date(eventdate * 1000); // Multiply by 1000 if the timestamp is in seconds
          
            // Format the date and time
            const formattedDateTime = `${date.toLocaleDateString()} ${date.toLocaleTimeString()}`;
          
            return (
              <div>
                <p>Date and Time: {formattedDateTime}</p>
              </div>
            );
          };
        const Tabs = () => {
            const [activeTab, setActiveTab] = useState('tab1');
            const handleTab1 = () => {
                setActiveTab('tab1');
            };
            const handleTab2 = () => {
                setActiveTab('tab2');
            };
            return (
                <div className="Tabs">
                    <ul className="navtab">
                        <li
                            style={{ justifyContent: 'center' }}
                            className={activeTab === 'tab1' ? 'active' : ''}
                            onClick={handleTab1}
                        >
                            <i className="fe fe-file-text"></i>
                            <div>New Complaint</div>
                        </li>
                        <li
                            className={activeTab === 'tab2' ? 'active' : ''}
                            onClick={handleTab2}
                        >
                            <i className="fe fe-bookmark"></i>
                            <div>My Complaints</div>
                        </li>
                    </ul>
                    <div className="outlet">
                        {activeTab === 'tab1' ? <FirstTab /> : <SecondTab />}
                    </div>
                </div>
            );
        };

        return (
            <div className="container">
                <div
                    className="m-2 mt-4"
                    style={{ fontSize: '20px', display: 'flex' }}
                >
                    <div className="mr-4">
                        <a
                            href={RemoveLastDirectoryPartOf(
                                window.location.href
                            )}
                            style={{ textDecoration: 'none' }}
                        >
                            <i className="fe fe-arrow-left" />
                        </a>
                    </div>
                    <div>Complaints</div>
                </div>
                <Tabs></Tabs>
            </div>
        );
    }
}